import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MarkdownIt from "markdown-it";
import MdEditor from "react-markdown-editor-lite";
import "react-markdown-editor-lite/lib/index.css";
import { renderers } from "../qna/rederers";
import { CheckOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import axios from "axios";

const mdParser = new MarkdownIt({
  html: true,
  renderers: renderers,
});

const DoubtView = ({ doubt1, isTeacher, userId }) => {
  const { student, created_at, doubt, iscleared, _id, mentor } = doubt1;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [doubtDetails, setDoubtDetails] = useState("");
  const [answers, setAnswers] = useState([]);
  const [answersloading, setAnswersLoading] = useState(false);
  const [laodingAdd, setAddLoading] = useState(false);
  const [loadingclear, setClearLoading] = useState(false);
  const handleEditorChange = ({ text }) => {
    setDoubtDetails(text);
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const showModal1 = () => {
    setIsModalOpen1(true);
  };
  const handleCancel1 = () => {
    setIsModalOpen1(false);
  };
  const handleFetchAnswer = async () => {
    setAnswersLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/getdoubtanswers?doubtId=${_id}`,
        {
          headers,
        }
      );
      console.log(res);
      if (res.data) {
        setAnswers(res.data);
      } else {
        console.log("No Answers");
        setAnswers([]);
      }
    } catch (err) {
      console.log("Error While Fetching Answer");
    }
    setAnswersLoading(false);
  };
  const handleAddAnswer = async () => {
    setAddLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/answerdoubt`,
        {
          doubtId: _id,
          answer: doubtDetails,
        },
        {
          headers,
        }
      );
      console.log(res);
      alert(res?.data?.message);
      handleCancel();
      handleFetchAnswer();
    } catch (err) {
      console.log("Error While Adding Answer");
    }
    setAddLoading(false);
  };
  const handleClearDoubt = async () => {
    setClearLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/markdoubtcleared`,
        {
          questionId: _id,
          studentId: userId,
        },
        {
          headers,
        }
      );
      console.log(res);
      alert(res?.data?.message);
      handleFetchAnswer();
    } catch (err) {
      alert("Error While Clear");
    }
    setClearLoading(false);
  };
  const handleImageUpload = async (file) => {
    try {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          const base64String = reader.result;
          resolve(base64String);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    } catch (error) {
      console.error("Error uploading image:", error);
      return null;
    }
  };
  useEffect(() => {
    handleFetchAnswer();
  }, []);
  return (
    <div className="bg-white rounded-lg shadow-lg p-4 w-full">
      {isTeacher ? (
        <h2 className="text-lg font-bold">Asked by: {student?.email}</h2>
      ) : (
        <h2 className="text-lg font-bold">Asked to: {mentor?.email}</h2>
      )}

      <h2
        className={`w-full text-right text-lg font-bold mb-1 text-${
          iscleared ? "green" : "red"
        }-500`}
      >
        {iscleared ? (
          <>
            <div className="flex justify-end gap-1 align-items-center">
              Cleared
              <CheckOutlined />
            </div>
          </>
        ) : (
          <div className="flex justify-end gap-1 align-items-center">
            Pending
            <QuestionCircleOutlined />
          </div>
        )}
      </h2>
      <div className="text-right w-full mb-2">
        <span className="text-gray-500 text-sm">Asked At: {created_at}</span>
      </div>
      <MdEditor
        value={doubt}
        renderHTML={(text) => {
          const modifiedText = text;
          return mdParser.render(modifiedText);
        }}
        view={{ menu: false, md: false, html: true }}
      />
      <p className="text-gray-500 text-sm mt-2">Doubt ID: {_id}</p>

      <div className="pt-3 w-full text-right">
        {isTeacher ? (
          <Button
            onClick={showModal}
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold "
          >
            Answer
          </Button>
        ) : (
          <Button
            onClick={iscleared ? () => {} : handleClearDoubt}
            className="bg-green-500 hover:bg-green-600 text-white font-bold "
            disabled={iscleared}
            loading={loadingclear}
            style={{ display: iscleared ? "none" : "" }}
          >
            {!iscleared ? "Cleared ?" : "Doubt Cleared"}
          </Button>
        )}
        {answers?.length > 0 && (
          <Button
            onClick={showModal1}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold ml-2"
          >
            View Answes
          </Button>
        )}
      </div>
      <Modal
        title="Add Answer"
        open={isModalOpen}
        onOk={() => {}}
        onCancel={handleCancel}
        footer={[
          <Button className="bg-gray-50" key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            className="bg-blue-600"
            loading={laodingAdd}
            onClick={handleAddAnswer}
          >
            Submit
          </Button>,
        ]}
      >
        <form onSubmit={handleAddAnswer} className="my-4">
          <div className="pt-3">
            <MdEditor
              id="details"
              placeholder="e.g. I didn't understand this part,here is the attached screenshot..."
              value={doubtDetails}
              style={{ height: "200px" }}
              renderHTML={(text) => {
                const modifiedText = text;
                return mdParser.render(modifiedText);
              }}
              onChange={handleEditorChange}
              onImageUpload={handleImageUpload}
              view={{
                markdown: true,
                html: false,
                fullScreen: false,
                hideMenu: false,
              }}
              config={{
                view: {
                  menu: true,
                  md: true,
                  html: false,
                },
                canView: {
                  menu: true,
                  md: true,
                  html: true,
                  fullScreen: true,
                  hideMenu: true,
                },
                markdownClass: "markdown-body",
              }}
            />
          </div>
        </form>
      </Modal>
      <Modal
        title="Answers"
        open={isModalOpen1}
        onOk={handleCancel1}
        onCancel={handleCancel1}
        footer={[
          <Button className="bg-gray-50" key="back" onClick={handleCancel1}>
            Cancel
          </Button>,
        ]}
        width={1000}
      >
        {answersloading && "Loading.."}
        <div className="my-2 p-2" style={{ height: "400px", overflow: "auto" }}>
          {!answersloading &&
            answers.map((answer, index) => {
              return (
                <div
                  key={index}
                  className="bg-gray-200 rounded-lg shadow-sm p-4 w-full mb-2"
                >
                  <MdEditor
                    value={answer.answer}
                    renderHTML={(text) => {
                      const modifiedText = text;
                      return mdParser.render(modifiedText);
                    }}
                    view={{ menu: false, md: false, html: true }}
                  />
                  <div className="text-gray-500 text-sm mb-2 w-full text-right">
                    {answer.created_at}
                  </div>
                </div>
              );
            })}
        </div>
      </Modal>
    </div>
  );
};

export default DoubtView;
